import { Alert, Box, Button, Grid, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import JsonPanel from "../json-panel/JsonPanel";
import { Campo, Indicadores } from "./Elementos";
import { XmlResultado } from "./Totalizadores";
const rotulo = (k) =>
  ({
    totalIdentificadoresRetornados: "Identificadores retornados",
    totalizadoresEncontrados: "Totalizadores encontrados",
    totalizadoresJaExistentes: "Já existentes",
    totalizadoresParaDownload: "Candidatos ao download",
    totalIdentificadoresJaExistentes: "Identificadores existentes",
    totalIdentificadoresParaDownload: "Identificadores para download",
    totalSolicitacoesDownload: "Solicitações realizadas",
    totalizadoresSalvos: "Salvos na Folha",
    totalFalhasDownload: "Falhas de download",
    sincronizacaoPendente: "Sincronização pendente",
    observacao: "Observação",
    concluido: "Concluído",
    temMais: "Há mais registros"
  }[k] || k.replace(/([A-Z])/g, " $1").replace(/^./, (c) => c.toUpperCase()));
export default function ResultadoOperacao({ result, type = "json" }) {
  if (result === undefined) return null;
  if (
    type === "xml" ||
    (typeof result === "string" && result.trim().startsWith("<"))
  )
    return <XmlResultado xml={result} />;
  if (result === null || result === "")
    return (
      <Alert severity="info">
        Solicitação concluída sem conteúdo de resposta. Consulte a situação
        atual antes de repetir uma ação.
      </Alert>
    );
  if (typeof result !== "object")
    return <Alert severity="info">{String(result)}</Alert>;
  const recuperacao = Object.prototype.hasOwnProperty.call(
    result,
    "totalizadoresSalvos"
  );
  const valores = Object.entries(result).filter(
    ([k, v]) => typeof v === "number"
  );
  const resumo = recuperacao
    ? [
        "totalizadoresEncontrados",
        "totalizadoresJaExistentes",
        "totalizadoresSalvos",
        "totalFalhasDownload"
      ]
        .filter((k) => result[k] !== undefined)
        .map((k) => [k, result[k]])
    : valores.slice(0, 4);
  return (
    <Stack spacing={2}>
      <Typography variant="h6">Resultado da operação</Typography>
      {result.sincronizacaoPendente && (
        <Alert
          severity="warning"
          action={
            <Button component={Link} to="/pendencias" color="inherit">
              Consultar fila
            </Button>
          }
        >
          Recuperação recebida. A aplicação na Folha ainda depende da fila de
          sincronização.
        </Alert>
      )}
      {Number(result.totalFalhasDownload) > 0 && (
        <Alert severity="error">
          Parte das solicitações falhou. Confira os detalhes antes de tentar
          recuperar novamente.
        </Alert>
      )}
      {recuperacao &&
        !result.sincronizacaoPendente &&
        result.totalizadoresSalvos === 0 && (
          <Alert severity="info">
            Nenhum totalizador novo foi confirmado na Folha nesta operação.
            Verifique os itens já existentes e as observações.
          </Alert>
        )}
      {resumo.length > 0 && (
        <Indicadores
          compacto
          items={resumo.map(([k, v]) => ({ label: rotulo(k), value: v }))}
        />
      )}
      <Grid container spacing={2}>
        {Object.entries(result)
          .filter(
            ([k, v]) =>
              v !== null &&
              typeof v !== "object" &&
              !resumo.some(([rk]) => rk === k) &&
              k !== "sincronizacaoPendente"
          )
          .map(([k, v]) => (
            <Grid item xs={12} md={6} key={k}>
              <Campo
                label={rotulo(k)}
                value={typeof v === "boolean" ? (v ? "Sim" : "Não") : v}
              />
            </Grid>
          ))}
      </Grid>
      {Array.isArray(result) && (
        <Alert severity="info">{result.length} registros retornados.</Alert>
      )}
      <Box>
        <JsonPanel
          primary="Detalhes do retorno"
          secondary="Identificadores, recibos e demais informações para conferência"
          src={result}
          collapsed
        />
      </Box>
    </Stack>
  );
}
